import {ValueDefinition} from '@/model/types';

export const enum Redeemability {
  REDEEMABLE = 'DV-31#0',
  NON_REDEEMABLE = 'DV-31#1',
}

export const DV_31 = {
  id: 'DV-31',
  description: {
    fr: 'Rachetable ou non',
    en: 'Redeemable or not',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Rachetable',
        en: 'Redeemable',
      },
      acronym: {
        fr: 'R',
        en: 'R',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Non-rachetable',
        en: 'Non-redeemable',
      },
      acronym: {
        fr: 'NR',
        en: 'NR',
      },
    },
  ],
} as const satisfies ValueDefinition;
